// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-custom-width.modal-dialog {
  min-width: 44rem !important;
  max-width: 44rem !important;
}

.modal-content .about-modal .cald-modal-body {
  padding: 2rem;
}
.modal-content .about-modal .cald-modal-body .about-row {
  display: flex;
  justify-content: space-between;
  padding: 0.8rem 0;
  border-bottom: solid 0.1rem #e5e5e5;
  font-size: 1.4rem;
}
.modal-content .about-modal .cald-modal-body .about-row:last-child {
  border-bottom: none;
}
.modal-content .about-modal .cald-modal-body .about-row .about-label {
  color: #4a4a4a;
  font-weight: bold;
}
.modal-content .about-modal .cald-modal-body .about-row .about-value {
  color: #32363a;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/about-modal/about-modal.component.scss"],"names":[],"mappings":"AACE;EAEE,2BAAA;EACA,2BAAA;AADJ;;AAOI;EACE,aAAA;AAJN;AAMM;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,mCAAA;EACA,iBAAA;AAJR;AAMQ;EACE,mBAAA;AAJV;AAOQ;EACE,cAAA;EACA,iBAAA;AALV;AAQQ;EACE,cAAA;AANV","sourcesContent":[".modal-custom-width {\n  &.modal-dialog {\n    // This will replace default width of the modal which is set in modal.scss\n    min-width: 44rem !important;\n    max-width: 44rem !important;\n  }\n}\n\n.modal-content {\n  .about-modal {\n    .cald-modal-body {\n      padding: 2rem;\n\n      .about-row {\n        display: flex;\n        justify-content: space-between;\n        padding: 0.8rem 0;\n        border-bottom: solid 0.1rem #e5e5e5;\n        font-size: 1.4rem;\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        .about-label {\n          color: #4a4a4a;\n          font-weight: bold;\n        }\n\n        .about-value {\n          color: #32363a;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
